export const PAGE_ROUTES = {
  /** General Routes */
  Root: "/",

  /** Common Routes */
  COMMON: {
    MaintenanceMode: "/maintenance",
    Licence:"/licence"
  },

  /** Authentication Routes */
  AUTHENTICATION: {
    SignUp: "/signup",
    PractitionerSignUp: "/practitioner/signup",
    Login: "/login",
    ForgotPassword: "/forgotPassword",
    UpdatePassword: "/update-password",
    ChangePassword: "/changePassword",
    Signout: "/signout",
  },

  /** Admin Routes */
  ADMIN: {
    Desert: "/admin",
    Dashboard: "/admin/dashboard",
    DashboardAppointments: "/admin/dashboard/appointments",
    DashboardSubscription: "/admin/dashboard/subscriptions",
    DashboardOccupancy: "/admin/dashboard/occupancy",
    Configurations: "/admin/configurations",
    Calendar: "/admin/calendar",
    UpsertConfigurations: "/admin/configurations/upsert/:id",
    PractitionersManagement: "/admin/practitioner-management",
    RoomsManagement: "/admin/room-management",
    Payments: "/admin/payments",
    Reports: "/admin/reports",
    BookAppointment: "/admin/appointments/book-appointment",
    TherapySessions: "/admin/therapy-sessions",
    PatientsManagement: "/admin/patient-management",
    AddPatient: "/admin/patient-management/add-patient",
    PatientProfile: "/admin/patient-management/patient-profile",
    ConsentForm: "/admin/patient-management/consent-form",
    CryoChamberForm: "/admin/patient-management/cryo-chamber-form",
    infraredConsentForm: "/admin/patient-management/infrared-consent form",
    AirpodForm: "/admin/patient-management/airpod-form",
    PatientsCalender: "/admin/patients-calender",
    EditAppointment: "/admin/appointments/edit-appointment",
  },

  /** Practitioner Routes */
  PRACTITIONER: {
    Desert: "/practitioner",
    Dashboard: "/practitioner/dashboard",
    Profile: "/practitioner/profile",
    AppointmentList: "/practitioner/appointments",
    BookAppointment: "/practitioner/appointments/book-appointment",
    Calender: "/practitioner/calender",
    Subscription: "/practitioner/subscription",
    BuySubscription: "/practitioner/subscription/buy",
    SubscriptionSuccess: "/practitioner/subscription/success",
    SubscriptionFailure: "/practitioner/subscription/failed",
    Payments: "/practitioner/payments",
  },

  /** Patient Routes */
  PATIENT: {
    Desert: "/patient",
    Dashboard: "/patient/dashboard",
    BookAppointment: "/patient/book-appointment",
    ConfirmAppointment: "/patient/book-appointment/confirm-appointment",
    BookingSuccess: "/patient/booking/success",
    BookingFailure: "/patient/booking/failed",
    Profile: "/patient/profile",
    BookTherapySession: "/patient/book-therapy-session",
    ConfirmTherapySession: "/patient/confirm-therapy-session",
    UpdateTherapySession: "/patient/update-therapy-session",
    CheckoutSuccess: "/patient/checkout/success",
    CheckoutFailure: "/patient/checkout/failed",
    BookSessionSuccess: "/patient/session/success",
    BookSessionFailure: "/patient/session/failed",
    MembershipPackage: "/patient/membership-package",
    MembershipPackageSuccess: "/patient/membership-package/success",
    MembershipPackageFailure: "/patient/membership-package/failed",
    ConsentForm: "/patient/consent-form",
    CryoChamberForm: "/patient/consent-form/cryo-chamber-form",
    infraredConsentForm: "/patient/consent-form/infrared-consent form",
    AirpodForm: "/patient/consent-form/airpod-form",
    Notes: "/patient/notes",
    Calender: "/patient/calender",
  },

  /** Super Admin */
  SUPER_ADMIN: {
    Desert: "/super",
    Dashboard: "/super/dashboard",
  },

  /** Receptionist */
  RECEPTIONIST: {
    Desert: "/receptionist",
    ChangePassword: "/receptionist/change-password",
  },
};
